import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import Icon from '@mui/material/Icon'
import IconButton from '@mui/material/IconButton'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { styled } from '@mui/material/styles'
import React from 'react'

import Tooltip from '@/app/component/atom/tooltip'

type Props = {
  callContactMode: boolean
  disabled?: boolean
  onCallContactModeChange: (enabled: boolean) => void
}

const ContactsSettingsMenu: React.FC<Props> = ({ callContactMode, disabled = false, onCallContactModeChange }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

  return (
    <>
      <Tooltip title="CATI contacts settings">
        <IconButton
          aria-label="CATI contacts settings"
          id="cati-contacts-settings-button"
          onClick={(event: React.MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget)}
        >
          <Icon>settings</Icon>
        </IconButton>
      </Tooltip>
      <Menu
        id="cati-contacts-settings-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <StyledMenuItem disableGutters>
          <StyledFormControlLabel
            control={
              <Checkbox
                checked={callContactMode}
                color="primary"
                disabled={disabled}
                value="call-contact-mode"
                onChange={(event) => onCallContactModeChange(event.target.checked)}
              />
            }
            label="Call contacts from list"
          />
        </StyledMenuItem>
      </Menu>
    </>
  )
}

const StyledMenuItem = styled(MenuItem)({
  padding: '4px 16px',
})

const StyledFormControlLabel = styled(FormControlLabel)({
  margin: 0,
})

export default ContactsSettingsMenu
